class ChatMessage {

    constructor({id, textMessage, room, hidden, auto, unsent, timestamp, msgType, author, authorSid, isOther, authorIdentity, index, attributes, roomId, roomLastConsumedMessageIndex}) {
        this.id = id;
        this.textMessage = textMessage;
        this.room = room;
        if(hidden == true || hidden == false) this.hidden = hidden;
        else this.hidden = false;

        if(auto == true || auto == false) this.auto = auto;
        else this.auto = false;

        if(unsent == true || unsent == false) this.unsent = unsent;
        else this.unsent = false;

        this.timestamp = timestamp;
        this.msgType = msgType;
        this.author = author;
        this.authorSid = authorSid; 
        this.authorIdentity = authorIdentity;
        this.isOther = isOther;
        this.index = index;
        this.attributes = attributes
        this.roomId = roomId;
        this.roomLastConsumedMessageIndex = roomLastConsumedMessageIndex;
    }

    setIsOther(isOther){
        this.isOther = isOther
    }
}

export default ChatMessage;



// WEBPACK FOOTER //
// ./src/platform/chat/model/ChatMessage.js